import { Box, Stack, TextField, Typography } from '@mui/material'
import CodeTag from 'src/components/CodeTag'
import CopyButton from 'src/components/CopyButton'

/** The key in fours, as the apps that take it by hand show it. */
const grouped = (secret: string) => secret.match(/.{1,4}/g)?.join(' ') ?? secret

/**
 * The QR code an authenticator app scans, the same key to type in by hand,
 * and the field for the code the app then shows: the step that proves the
 * app was set up.
 */
export default function AuthenticatorScan({
  qrSvg,
  secret,
  code,
  onCodeChange,
  disabled,
}: {
  qrSvg: string
  secret: string
  code: string
  onCodeChange: (code: string) => void
  disabled?: boolean
}) {
  return (
    <Stack spacing={2} alignItems="center">
      <Box
        component="img"
        src={`data:image/svg+xml;utf8,${encodeURIComponent(qrSvg)}`}
        alt="QR code to scan with your authenticator app"
        sx={{ width: '60%', maxWidth: '100%', aspectRatio: '1' }}
      />
      <Typography variant="body2" color="text.secondary" textAlign="center">
        Cannot scan it? Type this key into the app instead:
      </Typography>
      <Stack direction="row" spacing={1} alignItems="center">
        <CodeTag>{grouped(secret)}</CodeTag>
        <CopyButton value={secret} label="Copy the key" />
      </Stack>
      <TextField
        label="Code from the app"
        autoComplete="one-time-code"
        inputProps={{ inputMode: 'numeric', maxLength: 7 }}
        value={code}
        onChange={(event) => onCodeChange(event.target.value)}
        disabled={disabled}
        fullWidth
      />
    </Stack>
  )
}
